const show_more_less_btns = document.querySelectorAll(".show-more-less-btn");

show_more_less_btns.forEach(function (btn) {
    btn.addEventListener("click", function (event) {
        event.preventDefault();

        const container = event.target.parentElement.closest('.expandable-container');
        if (container) {
            container.classList.toggle('expanded');
        }

        const plusminus = container.querySelector(".plusminus");
        if (plusminus) {
            if (container.classList.contains("expanded")) {
                plusminus.classList.add("active");
            } else {
                plusminus.classList.remove("active");
            }
        }
    });
});
